export const RESERVED_WORDS = [
	'abstract',
	'assert',
	'boolean',
	'break',
	'byte',
	'case',
	'catch',
	'char',
	'class',
	'continue',
  'component',
	'default',
	'do',
	'double',
	'else',
	'extends',
	'enum',
	'false',
	'final',
	'finally',
	'float',
	'for',
	'goto',
	'id',
	'if',
	'implements',
	'import',
	'instanceof',
	'int',
	'interface',
	'long',
	'native',
	'new',
	'null',
  'object',
	'package',
	'private',
	'protected',
	'public',
	'return',
	'short',
	'static',
	'strictfp',
	'super',
	'switch',
	'synchronized',
	'this',
	'throw',
	'throws',
	'transient',
	'true',
	'try',
	'void',
	'volatile',
	'while',
	'allocated',
	'select',
	'from',
	'to',
	'into',
	'constraint',
	'not',
	'null',
	'*',
	'where',
	'when',
	'and',
	'all',
	'by',
	'join',
	'union',
	'outer',
	'end',
	'else',
	'if',
	'having',
	'in',
	'inner',
	'is',
	'unique',
	'position',
	'result'
]

// These words are not Java keywords, but they collide with identifiers used
// by the MERODE Java code generator (e.g. `Collection`, `Constraint`, `State`,
// `Foreign`, `i`, `Item` are all generated class/variable names). Using them
// as a model element name breaks the generated code, so they are rejected
// separately from RESERVED_WORDS. `constraint` is already covered above, so
// it is not repeated here.
export const GENERATOR_RESERVED_WORDS = ['collection', 'state', 'foreign', 'item', 'i'];

export default RESERVED_WORDS;
